import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import {AnimationContents} from '../../../../AnimationContents';
import {ButtonController} from '../../../Common/ButtonController';
import {GameModel} from '../../../Models/GameModel';
import {IPictureTexture} from '../../Screens/Catalog/CatalogFolderController';
import {Container, Sprite} from 'pixi.js';
import {BlueButtonTextStyle, GreenButtonTextStyle, TitleTextStyle} from '../../../Constants/TextStyles';
import {GameEvent, GameEventPopupButtonName, GameEventPopupName} from '../../../Constants/GameEvent';
import {AdsLogic} from "../../../Logic/Ads/AdsLogic";
import {ConfirmationsYouRewardType} from './ConfirmationsYouRewardController';
import {REWARDED_ADS_TYPE} from "../../../Logic/Ads/BaseAdsLogic";

export interface IConfirmationsBuyEmbroideryControllerOptions {
    texture: IPictureTexture;
    type?: ConfirmationsYouRewardType,
    text?: 'A you sure?';
    valueText: '100x100';
    buyText?: 'BUY';
    receiveText?: 'GET';
    buyClick?: () => {};
    receiveClick?: () => {};
    exitClick?: () => {};
    buyDisabled: boolean;
    receiveDisabled: boolean;
}

export class ConfirmationsBuyEmbroideryController extends AnimationBaseController {
    $model: GameModel;

    protected rewardedButton: ButtonController;
    protected timerId;

    public constructor(
        @Inject private _options: IConfirmationsBuyEmbroideryControllerOptions,
        @Inject private _modelEvents: ModelEvents,
        @Inject protected adsLogic: AdsLogic,
        @Inject private _model: GameModel,
    ) {
        super('ConfirmationsBuyEmbroideryController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CONFIRMATIONS_JSON,
            libraryName: 'confirmations_container',
            childControllers: {
                buy_embroidery_buy: {
                    controller: ButtonController,
                    instanceName: 'confirmations.buy_embroidery.buy_embroidery_buy',
                    options: {
                        disabled: this._options.buyDisabled,
                        label: this._options.buyText || '',
                        onClick: () => {
                            if (this._options.buyClick) {
                                this._options.buyClick();
                                this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_buy')[0].interactive = false;

                                // this._modelEvents.dispatch(this._model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.unlock, buttonName: GameEventPopupButtonName.buy });
                            }
                        },
                    },
                },
                buy_embroidery_receive: {
                    controller: ButtonController,
                    instanceName: 'confirmations.buy_embroidery.buy_embroidery_receive',
                    options: {
                        disabled: this._options.receiveDisabled,
                        label: this._options.receiveText || '',
                        onClick: (isEnabled: boolean) => {
                            if (!isEnabled) return;
                            if (this._options.receiveClick) {
                                this._options.receiveClick();
                                this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_receive')[0].interactive = false;

                                // this._modelEvents.dispatch(this._model, GameEvent.popupButtonClick, { buttonName: GameEventPopupButtonName.viewAds });
                            }
                        },
                    },
                },
                buy_embroidery_exit: {
                    controller: ButtonController,
                    instanceName: 'confirmations.buy_embroidery.buy_embroidery_exit',
                    options: {
                        onClick: () => {
                            if (this._options.exitClick) {
                                this._modelEvents.dispatch(this._model, GameEvent.popupButtonClick, { buttonName: GameEventPopupButtonName.close });

                                this._options.exitClick();
                                this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_exit')[0].interactive = false;
                            }
                        },
                    },
                },
            },
        };
    }

    protected onInitialize() {
        this.rewardedButton = this.$childControllers.get<ButtonController>('buy_embroidery_receive');
        if (this.adsLogic.isReady && !this.adsLogic.adsLogic.isAvailableRewardedAd(REWARDED_ADS_TYPE.CATALOG_PICTURE)) {
            this.timerUpdate();
            this.rewardedButton.disabled();
        }

        this.init();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    private timerUpdate(): void {
        // if (!this.adsLogic.isReady) return;
        if (this.adsLogic.adsLogic.isAvailableRewardedAd(REWARDED_ADS_TYPE.CATALOG_PICTURE)) {
            // this.hideTimer();
            this.rewardedButton.label = this._options.receiveText || '';
            this.rewardedButton.enabled();
            return;
        }

        const date = new Date(this.adsLogic.adsLogic.timeoutBeforeRewardedAd(REWARDED_ADS_TYPE.CATALOG_PICTURE));
        const hours = Math.min(3, date.getUTCHours());
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        this.rewardedButton.label = `${hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
        console.log(`${hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`)

        this.timerId = setTimeout(() => {
            this.timerUpdate();
        }, 1000);
    }

    protected onDestroy(): void {
        clearTimeout(this.timerId);
        super.onDestroy();
    }

    public init(): void {
        if (this.adsLogic.isReady && !this.adsLogic.adsLogic.isAvailableRewardedAd(REWARDED_ADS_TYPE.CATALOG_PICTURE)) {
            this.timerUpdate();
            this.rewardedButton.disabled();
        }

        this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_buy')[0].interactive = true;
        this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_receive')[0].interactive = true;
        this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_exit')[0].interactive = true;

        const texture = this._options.texture || null;

        if (texture) {
            const placeholder = ((this.getDisplayObjectByQuery('confirmations.buy_embroidery.buy_embroidery_icon.icon_minipicture')[0] as Container).getChildAt(0) as Sprite);
            placeholder.texture = texture.texture;
            placeholder.width = 241;
            placeholder.height = 241;
        } else if (this._options.type) {
            this.gotoAndStopByQuery('confirmations.buy_embroidery.buy_embroidery_icon', this._options.type);
        }

        this.gotoAndStopByQuery('confirmations', 'buy_embroidery');

        this.setTextByQuery('confirmations.buy_embroidery.buy_embroidery_title', this._options.text || '');
        this.setTextStyleByQuery('confirmations.buy_embroidery.buy_embroidery_title', TitleTextStyle);

        this.setTextVerticalAlignByQuery('confirmations.buy_embroidery.buy_embroidery_title', 'middle');

        this.setTextByQuery('confirmations.buy_embroidery.buy_embroidery_icon.txt_value', this._options.valueText || '');

        this.setTextByQuery('confirmations.buy_embroidery.buy_embroidery_buy.label', this._options.buyText || '');
        this.setTextByQuery('confirmations.buy_embroidery.buy_embroidery_buy.txt_price', this._options.buyText || '');
        this.setTextStyleByQuery('confirmations.buy_embroidery.buy_embroidery_buy.label', BlueButtonTextStyle);
        this.setTextStyleByQuery('confirmations.buy_embroidery.buy_embroidery_buy.txt_price', BlueButtonTextStyle);

        this.setTextByQuery('confirmations.buy_embroidery.buy_embroidery_receive.label', this._options.receiveText || '');
        this.setTextByQuery('confirmations.buy_embroidery.buy_embroidery_receive.txt_price', this._options.receiveText || '');
        this.setTextStyleByQuery('confirmations.buy_embroidery.buy_embroidery_receive.label', GreenButtonTextStyle);
        this.setTextStyleByQuery('confirmations.buy_embroidery.buy_embroidery_receive.txt_price', GreenButtonTextStyle);

        if (this._options.buyDisabled) {
            this.$childControllers.get<ButtonController>('buy_embroidery_buy').disabled();
        } else {
            this.$childControllers.get<ButtonController>('buy_embroidery_buy').enabled();
        }

        if (this._options.receiveDisabled) {
            this.$childControllers.get<ButtonController>('buy_embroidery_receive').disabled();
        } else {
            this.$childControllers.get<ButtonController>('buy_embroidery_receive').enabled();
        }
    }
}
